import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateAICampaignRecipientEmail } from './useAICampaignRecipientEmail';
import { invalidateAICampaignRecipients } from './useAICampaignRecipients';

interface UpdateRecipientVariables {
	bulkEmailMessageId: string;
	contactId: string;
	subject: string;
	content: Api.IRawRichTextContentState;
}

export const useUpdateCampaignRecipient = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation<Api.ICampaign, Api.IOperationResultNoValue, UpdateRecipientVariables>({
		mutationFn: ({ bulkEmailMessageId, contactId, subject, content }) => {
			return userSession.webServiceHelper.callAsync<Api.ICampaign>(
				`Email/${encodeURIComponent(bulkEmailMessageId)}/recipients/${encodeURIComponent(contactId)}`,
				'PUT',
				{ subject, content }
			);
		},
		onError,
		onSuccess: (_data, variables) => {
			invalidateAICampaignRecipients(variables.bulkEmailMessageId);
			invalidateAICampaignRecipientEmail(variables.bulkEmailMessageId, variables.contactId);
			onSuccess?.();
		},
	});
};
